import * as React from 'react';
const SvgPublishIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={20} fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.517 4.173c.727-2.079-1.254-3.794-3.173-3.228a.86.86 0 0 0-.034.011L2.028 5.505c-2.312.741-2.244 3.997.1 4.703l.025.007 4.456 1.197.029.007c.68.158 1.203.684 1.456 1.495l1.189 4.452v.002c.623 2.366 3.876 2.376 4.692.154l.007-.019 4.535-13.33ZM15.83 2.54c.778-.22 1.334.453 1.112 1.084l-4.536 13.332c-.302.802-1.338.651-1.512-.013L9.7 12.468a.857.857 0 0 0-.008-.029c-.385-1.253-1.287-2.315-2.663-2.64l-4.43-1.19c-.825-.257-.758-1.297-.058-1.519l.018-.006L15.831 2.54Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPublishIcon;
